import * as React from "react"
import { Loader2 } from "lucide-react"

import { cn } from "@/infrastructure/lib/utils"
import { useMagicFill } from "@/shared/contexts/MagicFillContext"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean
  fieldKey?: string
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, fieldKey, disabled, ...props }, ref) => {
    const { isGlobalLoading, isFieldLoading } = useMagicFill();
    const isLoading = isGlobalLoading || (fieldKey ? isFieldLoading(fieldKey) : false);
    const isDisabled = disabled || isLoading;

    return (
      <div className="relative w-full">
        <textarea
          className={cn(
            "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-destructive focus-visible:ring-destructive",
            isLoading && "pr-9",
            className
          )}
          ref={ref}
          disabled={isDisabled}
          {...props}
        />
        {isLoading && (
          <div className="absolute right-3 top-3">
            <Loader2 className="h-4 w-4 animate-spin text-primary" />
          </div>
        )}
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
